import React, { Component as C } from "react"
import PropTypes from "prop-types"
import { makeStyles } from "@cirrus/ui-kit"
import classNames from "classnames"

import { StatelessTextInput, Button } from "@cirrus/legacy/app-components/entries/lib.js"
import { withUseStyles } from "@cirrus/legacy/app-common/utils/withUseStyles.jsx"

import cv from "@cirrus/legacy/app-components/app/styles/colors/colors-default.less"

const useStyles = makeStyles({
  cnt: {
    display: "flex",
  },

  field: {
    border: `2px solid ${cv.gray100}`,
    borderRight: 0,
    paddingLeft: "15px",
    height: "50px",
    borderRadius: "4px 0 0 4px",
    backgroundColor: cv.gray80,
    opacity: "0.65",
    "&::placeholder": { color: cv.gray280 },
  },

  action: {
    borderRadius: 0,
    height: "50px",
    "&:last-child": { borderRadius: "0 4px 4px 0" },
  },
})

class TextInputWithActions extends C {
  constructor(props) {
    super(props)
  }

  onActionClick(action) {
    action.onClick(this.container)
  }

  render() {
    const { containerClass, controlLabel, value, placeholder, actions, classes } = this.props

    return (
      <div
        ref={(container) => {
          this.container = container
        }}
        className={containerClass}>
        <label className="control-label">{controlLabel}</label>

        <div className={classes.cnt}>
          <StatelessTextInput
            className={classes.field}
            value={value}
            placeholder={placeholder || ""}
            readOnly={true}
          />

          {actions &&
            actions.map((action, index) => {
              return (
                <Button
                  key={index}
                  className={classNames(classes.action, action.className)}
                  type={action.type || "link"}
                  disabled={action.disabled || false}
                  onClick={() => this.onActionClick(action)}>
                  {action.text}
                </Button>
              )
            })}
        </div>
      </div>
    )
  }
}

TextInputWithActions.propTypes = {
  containerClass: PropTypes.string,
  controlLabel: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,

  actions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      className: PropTypes.string,
      type: PropTypes.string,
      disabled: PropTypes.bool,
      onClick: PropTypes.func.isRequired,
    }),
  ),
}

export default withUseStyles(TextInputWithActions, useStyles)
